import type {
  AiAssistantEulaAcceptance,
  AiAssistantEulaStatus,
  AiCreateThreadRequest,
  AiImageAttachment,
  AiJob,
  AiSubmitMessageResponse,
  AiThread,
  AiThreadDetail,
} from 'common/api/v1/types'
import type { EdgeClient } from 'common/generated/edgeClient'

export class AiAssistantApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async getEula(): Promise<AiAssistantEulaStatus> {
    return this.edgeClient.getAiEula()
  }

  async acceptEula(version: string): Promise<AiAssistantEulaAcceptance> {
    return this.edgeClient.acceptanceAiEulas({ version })
  }

  async createThread(request: AiCreateThreadRequest = {}): Promise<AiThread> {
    return this.edgeClient.threadAis(request)
  }

  async listThreads(): Promise<AiThread[]> {
    return (await this.edgeClient.listAiThreads()).items
  }

  async getThread(id: string): Promise<AiThreadDetail> {
    return this.edgeClient.getAiThread(id)
  }

  async deleteThread(id: string): Promise<void> {
    await this.edgeClient.deleteAiThread(id)
  }

  async submitMessage(
    threadId: string,
    content: string,
    images: AiImageAttachment[] = [],
  ): Promise<AiSubmitMessageResponse> {
    return this.edgeClient.messageAiThread(threadId, { content, images })
  }

  async getJob(id: string): Promise<AiJob> {
    return this.edgeClient.getAiJob(id)
  }

  async cancelJob(id: string): Promise<AiJob> {
    return this.edgeClient.cancelAiJob(id)
  }
}
